module.exports = "<div class=\"table-extern\">\n    <app-table-generic [headerFields]=\"headerFields\" [rowsObject]=\"rowFields\"></app-table-generic>\n</div>"